import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { BuildchartComponent } from '../buildchart/buildchart.component';
import { MortgageService } from '../mortgage.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  healthDatanew: any;
  applicationurl: any;
  product_id: any;
  BuildchartData: any = [];
  RunQuote: any;
  buildData: any;
  @Input() datainInsurance: any;
  constructor(public dialog: MatDialog, public data: MortgageService) { }

  ngOnInit() {
    console.log("OOPP", this.datainInsurance);
    if (this.datainInsurance) {
      this.datainInsurance.forEach(res => {
        this.product_id = res.id_product;
        // this.applicationurl=res.application_url;
        this.RunQuote = res.run_quote;
      })

    }
  }

  Bulidchart() {
    console.log("Product", this.product_id)
    this.data.savebuildchart(this.product_id).subscribe(res => {
      console.log("Data achive", res.message);
      let obj = JSON.parse(res.message)
      this.BuildchartData = obj.result;
      console.log("Data achive", this.BuildchartData);
      if (this.BuildchartData) {
        sessionStorage.setItem("buildData", JSON.stringify(this.BuildchartData));
      }
    })

  }
  // OpenDialog(template) {
  //   let dialogRef = this.dialog.open(template);
  // }
  openDialog() {
    const dialogRef = this.dialog.open(BuildchartComponent);

  }
  runQuote() {
    window.open(this.RunQuote, '_blank');

  }

}
